// @ts-check
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import TitleTop from "../Shared/TitleTop/title-top";
import TitleIntroRichCtaSection from "../Shared/TitleIntroRichCtaSection/title-intro-rich-cta-section";

const ImageTextCtaList = ({ AnchorId, ...props }) => {
    const baseClass = "image-text-cta-list";
    const rootClasses = classNames(`${baseClass}-container content-module`, {
        [`${baseClass}--keep-image-aspect-ratio`]: props.KeepImageAspectRatio,
        "content-module--bg": props.BackgroundColorClass,
        [`${props.BackgroundColorClass}--bg`]: props.BackgroundColorClass,
        [`${props.TextColorClass}--text`]: props.TextColorClass,
        "content-module--no-margin-top": props.HasNoMarginTop,
        "content-module--no-margin-bottom": props.HasNoMarginBottom
    });

    // The styling differs from max-width 250 -> 175.
    // We multiply by 1.5 for retina
    const imageWidth = props.KeepImageAspectRatio ? 375 : 270;

    return (
        <div className={rootClasses}>
            <div className={baseClass}>
                <div className={`${baseClass}-inner content-module__landingpage-inner`}>
                    {props.Title && <TitleTop id={AnchorId} {...props} />}
                    <div className={`${baseClass}__list`}>
                        {props.ImageTextCtaList.length > 0 &&
                            props.ImageTextCtaList.map((item, index) => {
                                return (
                                    <div className={`${baseClass}__list-item`} key={index}>
                                        {item.ImageUrl && (
                                            <div className={`${baseClass}__image-wrapper`}>
                                                <img
                                                    loading="lazy"
                                                    src={`${item.ImageUrl}?w=${imageWidth}`}
                                                    alt={item.ImageAltText}
                                                />
                                            </div>
                                        )}
                                        <TitleIntroRichCtaSection {...item} AlignContent="center" IsTitleH3 />
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        </div>
    );
};

ImageTextCtaList.propTypes = {
    Title: PropTypes.string,
    AnchorId: PropTypes.string,
    IsTitleH1: PropTypes.bool,
    BackgroundColorClass: PropTypes.string,
    TextColorClass: PropTypes.string,
    HasNoMarginTop: PropTypes.bool,
    HasNoMarginBottom: PropTypes.bool,
    KeepImageAspectRatio: PropTypes.bool,
    ImageTextCtaList: PropTypes.arrayOf(
        PropTypes.shape({
            ImageUrl: PropTypes.string,
            ImageAltText: PropTypes.string,
            Title: PropTypes.string,
            RichText: PropTypes.string,
            CtaLink: PropTypes.string,
            CtaTextColorClass: PropTypes.string,
            CtaBackgroundColorClass: PropTypes.string,
            ShowCtaAsLink: PropTypes.bool
        })
    )
};

export default ImageTextCtaList;
